import styled from 'styled-components';
// old design
export const TableBodyCell = styled.td `
  //border: 1px solid grey;
  padding-left: 16px;
  height: 44px;
  text-align: left;
`;
// new design
export const TableBodyCellNew = styled.td `
  //border: 1px solid grey;
  padding: 10px;
  height: 48px;
  text-align: left;
  font-weight: inherit;
  font-size: 14px;
  line-height: 20px;
  color: #ffffff;
`;
export const TableBodyCellModal = styled(TableBodyCellNew) `
  padding: 0 10px 0 0;
  height: 48px;
  font-weight: inherit;
  &:last-child {
    padding-right: 0;
  }
`;
